/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StylesRouteImport } from './routes/styles'
import { Route as PublicRouteImport } from './routes/public'
import { Route as MappingRouteImport } from './routes/mapping'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicIndexRouteImport } from './routes/public/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as ResetIdRouteImport } from './routes/reset.$id'
import { Route as PublicChallengeRouteImport } from './routes/public/challenge'
import { Route as MagicIdRouteImport } from './routes/magic.$id'
import { Route as IndustriesSlugRouteImport } from './routes/industries/$slug'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthVcardRouteImport } from './routes/_auth/vcard'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthLandingRouteImport } from './routes/_auth/landing'
import { Route as AuthDraftsRouteImport } from './routes/_auth/drafts'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthGlobalRouteImport } from './routes/_auth/_global'
import { Route as PublicSitesIndexRouteImport } from './routes/public/sites/index'
import { Route as PublicProjectsIndexRouteImport } from './routes/public/projects/index'
import { Route as PublicOrgsIndexRouteImport } from './routes/public/orgs/index'
import { Route as AuthSitesIndexRouteImport } from './routes/_auth/sites/index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthProjectsIndexRouteImport } from './routes/_auth/projects/index'
import { Route as AuthOrgsIndexRouteImport } from './routes/_auth/orgs/index'
import { Route as AuthLoggersIndexRouteImport } from './routes/_auth/loggers/index'
import { Route as AuthChallengesIndexRouteImport } from './routes/_auth/challenges/index'
import { Route as AuthCablesIndexRouteImport } from './routes/_auth/cables/index'
import { Route as PublicSitesIdRouteImport } from './routes/public/sites/$id'
import { Route as PublicProjectsIdRouteImport } from './routes/public/projects/$id'
import { Route as PublicOrgsIdRouteImport } from './routes/public/orgs/$id'
import { Route as AuthUsersIdRouteImport } from './routes/_auth/users/$id'
import { Route as AuthSitesIdRouteImport } from './routes/_auth/sites/$id'
import { Route as AuthSettingsThresholdsRouteImport } from './routes/_auth/settings/thresholds'
import { Route as AuthSettingsBetaRouteImport } from './routes/_auth/settings/beta'
import { Route as AuthSettingsAppearanceRouteImport } from './routes/_auth/settings/appearance'
import { Route as AuthSettingsApiKeysRouteImport } from './routes/_auth/settings/api-keys'
import { Route as AuthProjectsIdRouteImport } from './routes/_auth/projects/$id'
import { Route as AuthOrgsIdRouteImport } from './routes/_auth/orgs/$id'
import { Route as AuthLoggersIdRouteImport } from './routes/_auth/loggers/$id'
import { Route as AuthChallengesSubmitRouteImport } from './routes/_auth/challenges/submit'
import { Route as AuthChallengesNewRouteImport } from './routes/_auth/challenges/new'
import { Route as AuthCablesIdRouteImport } from './routes/_auth/cables/$id'
import { Route as AuthGlobalWebhookEventsRouteImport } from './routes/_auth/_global/webhook-events'
import { Route as AuthGlobalTosAgreementsRouteImport } from './routes/_auth/_global/tos-agreements'
import { Route as AuthGlobalServiceManagerRouteImport } from './routes/_auth/_global/service-manager'
import { Route as AuthGlobalServiceItemsRouteImport } from './routes/_auth/_global/service-items'
import { Route as AuthGlobalSensorsRouteImport } from './routes/_auth/_global/sensors'
import { Route as AuthGlobalSearchRouteImport } from './routes/_auth/_global/search'
import { Route as AuthGlobalReconciliationRouteImport } from './routes/_auth/_global/reconciliation'
import { Route as AuthGlobalRecentUsersRouteImport } from './routes/_auth/_global/recent-users'
import { Route as AuthGlobalNotificationsRouteImport } from './routes/_auth/_global/notifications'
import { Route as AuthGlobalLoggerFirmwareManagementRouteImport } from './routes/_auth/_global/logger-firmware-management'
import { Route as AuthGlobalLoggerActivationsRouteImport } from './routes/_auth/_global/logger-activations'
import { Route as AuthGlobalLandingContentRouteImport } from './routes/_auth/_global/landing-content'
import { Route as AuthGlobalForecastRequestsRouteImport } from './routes/_auth/_global/forecast-requests'
import { Route as AuthGlobalDevicesRouteImport } from './routes/_auth/_global/devices'
import { Route as AuthGlobalDataUsageCalculatorRouteImport } from './routes/_auth/_global/data-usage-calculator'
import { Route as AuthGlobalContactSubmissionsRouteImport } from './routes/_auth/_global/contact-submissions'
import { Route as AuthGlobalCommandsRouteImport } from './routes/_auth/_global/commands'
import { Route as AuthGlobalCablePricingRouteImport } from './routes/_auth/_global/cable-pricing'
import { Route as AuthGlobalBomConfigurationRouteImport } from './routes/_auth/_global/bom-configuration'
import { Route as AuthSitesIdIndexRouteImport } from './routes/_auth/sites/$id/index'
import { Route as AuthProjectsIdIndexRouteImport } from './routes/_auth/projects/$id/index'
import { Route as AuthOrgsIdIndexRouteImport } from './routes/_auth/orgs/$id/index'
import { Route as AuthGlobalUsersIndexRouteImport } from './routes/_auth/_global/users.index'
import { Route as AuthGlobalReportTemplatesIndexRouteImport } from './routes/_auth/_global/report-templates/index'
import { Route as AuthGlobalPageAdminIndexRouteImport } from './routes/_auth/_global/page-admin/index'
import { Route as AuthGlobalOrdersIndexRouteImport } from './routes/_auth/_global/orders/index'
import { Route as AuthGlobalModemsIndexRouteImport } from './routes/_auth/_global/modems/index'
import { Route as AuthSitesIdTrumpetRouteImport } from './routes/_auth/sites/$id/trumpet'
import { Route as AuthProjectsIdWivReportRouteImport } from './routes/_auth/projects/$id/wiv-report'
import { Route as AuthProjectsIdReportRouteImport } from './routes/_auth/projects/$id/report'
import { Route as AuthProjectsIdGenerateReportRouteImport } from './routes/_auth/projects/$id/generate-report'
import { Route as AuthProjectsIdDevicesRouteImport } from './routes/_auth/projects/$id/devices'
import { Route as AuthOrgsIdDevicesRouteImport } from './routes/_auth/orgs/$id/devices'
import { Route as AuthGlobalReportTemplatesIdRouteImport } from './routes/_auth/_global/report-templates/$id'
import { Route as AuthGlobalPageAdminPageTypeRouteImport } from './routes/_auth/_global/page-admin/$pageType'
import { Route as AuthGlobalOrdersIdRouteImport } from './routes/_auth/_global/orders/$id'
import { Route as AuthGlobalModemsImeiRouteImport } from './routes/_auth/_global/modems/$imei'
import { Route as AuthGlobalLoggersStatusRouteImport } from './routes/_auth/_global/loggers/status'
import { Route as AuthGlobalPageAdminPageTypeIndexRouteImport } from './routes/_auth/_global/page-admin/$pageType/index'
import { Route as AuthGlobalPageAdminPageTypeIdOrSlugRouteImport } from './routes/_auth/_global/page-admin/$pageType/$idOrSlug'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StylesRoute = StylesRouteImport.update({
  id: '/styles',
  path: '/styles',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
} as any)
const MappingRoute = MappingRouteImport.update({
  id: '/mapping',
  path: '/mapping',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetIdRoute = ResetIdRouteImport.update({
  id: '/reset/$id',
  path: '/reset/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicChallengeRoute = PublicChallengeRouteImport.update({
  id: '/challenge',
  path: '/challenge',
  getParentRoute: () => PublicRoute,
} as any)
const MagicIdRoute = MagicIdRouteImport.update({
  id: '/magic/$id',
  path: '/magic/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
  id: '/industries/$slug',
  path: '/industries/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVcardRoute = AuthVcardRouteImport.update({
  id: '/vcard',
  path: '/vcard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLandingRoute = AuthLandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDraftsRoute = AuthDraftsRouteImport.update({
  id: '/drafts',
  path: '/drafts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGlobalRoute = AuthGlobalRouteImport.update({
  id: '/_global',
  getParentRoute: () => AuthRoute,
} as any)
const PublicSitesIndexRoute = PublicSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicProjectsIndexRoute = PublicProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOrgsIndexRoute = PublicOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthSitesIndexRoute = AuthSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthProjectsIndexRoute = AuthProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrgsIndexRoute = AuthOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoggersIndexRoute = AuthLoggersIndexRouteImport.update({
  id: '/loggers/',
  path: '/loggers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChallengesIndexRoute = AuthChallengesIndexRouteImport.update({
  id: '/challenges/',
  path: '/challenges/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCablesIndexRoute = AuthCablesIndexRouteImport.update({
  id: '/cables/',
  path: '/cables/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicSitesIdRoute = PublicSitesIdRouteImport.update({
  id: '/sites/$id',
  path: '/sites/$id',
  getParentRoute: () => PublicRoute,
} as any)
const PublicProjectsIdRoute = PublicProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOrgsIdRoute = PublicOrgsIdRouteImport.update({
  id: '/orgs/$id',
  path: '/orgs/$id',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUsersIdRoute = AuthUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSitesIdRoute = AuthSitesIdRouteImport.update({
  id: '/sites/$id',
  path: '/sites/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsThresholdsRoute = AuthSettingsThresholdsRouteImport.update({
  id: '/thresholds',
  path: '/thresholds',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsBetaRoute = AuthSettingsBetaRouteImport.update({
  id: '/beta',
  path: '/beta',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsAppearanceRoute = AuthSettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsApiKeysRoute = AuthSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthProjectsIdRoute = AuthProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrgsIdRoute = AuthOrgsIdRouteImport.update({
  id: '/orgs/$id',
  path: '/orgs/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoggersIdRoute = AuthLoggersIdRouteImport.update({
  id: '/loggers/$id',
  path: '/loggers/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChallengesSubmitRoute = AuthChallengesSubmitRouteImport.update({
  id: '/challenges/submit',
  path: '/challenges/submit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChallengesNewRoute = AuthChallengesNewRouteImport.update({
  id: '/challenges/new',
  path: '/challenges/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCablesIdRoute = AuthCablesIdRouteImport.update({
  id: '/cables/$id',
  path: '/cables/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGlobalWebhookEventsRoute = AuthGlobalWebhookEventsRouteImport.update({
  id: '/webhook-events',
  path: '/webhook-events',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalTosAgreementsRoute = AuthGlobalTosAgreementsRouteImport.update({
  id: '/tos-agreements',
  path: '/tos-agreements',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalServiceManagerRoute =
  AuthGlobalServiceManagerRouteImport.update({
    id: '/service-manager',
    path: '/service-manager',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalServiceItemsRoute = AuthGlobalServiceItemsRouteImport.update({
  id: '/service-items',
  path: '/service-items',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalSensorsRoute = AuthGlobalSensorsRouteImport.update({
  id: '/sensors',
  path: '/sensors',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalSearchRoute = AuthGlobalSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalReconciliationRoute =
  AuthGlobalReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalRecentUsersRoute = AuthGlobalRecentUsersRouteImport.update({
  id: '/recent-users',
  path: '/recent-users',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalNotificationsRoute = AuthGlobalNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalLoggerFirmwareManagementRoute =
  AuthGlobalLoggerFirmwareManagementRouteImport.update({
    id: '/logger-firmware-management',
    path: '/logger-firmware-management',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalLoggerActivationsRoute =
  AuthGlobalLoggerActivationsRouteImport.update({
    id: '/logger-activations',
    path: '/logger-activations',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalLandingContentRoute =
  AuthGlobalLandingContentRouteImport.update({
    id: '/landing-content',
    path: '/landing-content',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalForecastRequestsRoute =
  AuthGlobalForecastRequestsRouteImport.update({
    id: '/forecast-requests',
    path: '/forecast-requests',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalDevicesRoute = AuthGlobalDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalDataUsageCalculatorRoute =
  AuthGlobalDataUsageCalculatorRouteImport.update({
    id: '/data-usage-calculator',
    path: '/data-usage-calculator',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalContactSubmissionsRoute =
  AuthGlobalContactSubmissionsRouteImport.update({
    id: '/contact-submissions',
    path: '/contact-submissions',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalCommandsRoute = AuthGlobalCommandsRouteImport.update({
  id: '/commands',
  path: '/commands',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalCablePricingRoute = AuthGlobalCablePricingRouteImport.update({
  id: '/cable-pricing',
  path: '/cable-pricing',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalBomConfigurationRoute =
  AuthGlobalBomConfigurationRouteImport.update({
    id: '/bom-configuration',
    path: '/bom-configuration',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthSitesIdIndexRoute = AuthSitesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSitesIdRoute,
} as any)
const AuthProjectsIdIndexRoute = AuthProjectsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProjectsIdRoute,
} as any)
const AuthOrgsIdIndexRoute = AuthOrgsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgsIdRoute,
} as any)
const AuthGlobalUsersIndexRoute = AuthGlobalUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalReportTemplatesIndexRoute =
  AuthGlobalReportTemplatesIndexRouteImport.update({
    id: '/report-templates/',
    path: '/report-templates/',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalPageAdminIndexRoute =
  AuthGlobalPageAdminIndexRouteImport.update({
    id: '/page-admin/',
    path: '/page-admin/',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalOrdersIndexRoute = AuthGlobalOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalModemsIndexRoute = AuthGlobalModemsIndexRouteImport.update({
  id: '/modems/',
  path: '/modems/',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthSitesIdTrumpetRoute = AuthSitesIdTrumpetRouteImport.update({
  id: '/trumpet',
  path: '/trumpet',
  getParentRoute: () => AuthSitesIdRoute,
} as any)
const AuthProjectsIdWivReportRoute = AuthProjectsIdWivReportRouteImport.update({
  id: '/wiv-report',
  path: '/wiv-report',
  getParentRoute: () => AuthProjectsIdRoute,
} as any)
const AuthProjectsIdReportRoute = AuthProjectsIdReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthProjectsIdRoute,
} as any)
const AuthProjectsIdGenerateReportRoute =
  AuthProjectsIdGenerateReportRouteImport.update({
    id: '/generate-report',
    path: '/generate-report',
    getParentRoute: () => AuthProjectsIdRoute,
  } as any)
const AuthProjectsIdDevicesRoute = AuthProjectsIdDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthProjectsIdRoute,
} as any)
const AuthOrgsIdDevicesRoute = AuthOrgsIdDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthOrgsIdRoute,
} as any)
const AuthGlobalReportTemplatesIdRoute =
  AuthGlobalReportTemplatesIdRouteImport.update({
    id: '/report-templates/$id',
    path: '/report-templates/$id',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalPageAdminPageTypeRoute =
  AuthGlobalPageAdminPageTypeRouteImport.update({
    id: '/page-admin/$pageType',
    path: '/page-admin/$pageType',
    getParentRoute: () => AuthGlobalRoute,
  } as any)
const AuthGlobalOrdersIdRoute = AuthGlobalOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalModemsImeiRoute = AuthGlobalModemsImeiRouteImport.update({
  id: '/modems/$imei',
  path: '/modems/$imei',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalLoggersStatusRoute = AuthGlobalLoggersStatusRouteImport.update({
  id: '/loggers/status',
  path: '/loggers/status',
  getParentRoute: () => AuthGlobalRoute,
} as any)
const AuthGlobalPageAdminPageTypeIndexRoute =
  AuthGlobalPageAdminPageTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGlobalPageAdminPageTypeRoute,
  } as any)
const AuthGlobalPageAdminPageTypeIdOrSlugRoute =
  AuthGlobalPageAdminPageTypeIdOrSlugRouteImport.update({
    id: '/$idOrSlug',
    path: '/$idOrSlug',
    getParentRoute: () => AuthGlobalPageAdminPageTypeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/access-denied': typeof AccessDeniedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mapping': typeof MappingRoute
  '/public': typeof PublicRouteWithChildren
  '/styles': typeof StylesRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/drafts': typeof AuthDraftsRoute
  '/landing': typeof AuthLandingRoute
  '/settings': typeof AuthSettingsRouteWithChildren
  '/vcard': typeof AuthVcardRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/industries/$slug': typeof IndustriesSlugRoute
  '/magic/$id': typeof MagicIdRoute
  '/public/challenge': typeof PublicChallengeRoute
  '/reset/$id': typeof ResetIdRoute
  '/blog/': typeof BlogIndexRoute
  '/public/': typeof PublicIndexRoute
  '/bom-configuration': typeof AuthGlobalBomConfigurationRoute
  '/cable-pricing': typeof AuthGlobalCablePricingRoute
  '/commands': typeof AuthGlobalCommandsRoute
  '/contact-submissions': typeof AuthGlobalContactSubmissionsRoute
  '/data-usage-calculator': typeof AuthGlobalDataUsageCalculatorRoute
  '/devices': typeof AuthGlobalDevicesRoute
  '/forecast-requests': typeof AuthGlobalForecastRequestsRoute
  '/landing-content': typeof AuthGlobalLandingContentRoute
  '/logger-activations': typeof AuthGlobalLoggerActivationsRoute
  '/logger-firmware-management': typeof AuthGlobalLoggerFirmwareManagementRoute
  '/notifications': typeof AuthGlobalNotificationsRoute
  '/recent-users': typeof AuthGlobalRecentUsersRoute
  '/reconciliation': typeof AuthGlobalReconciliationRoute
  '/search': typeof AuthGlobalSearchRoute
  '/sensors': typeof AuthGlobalSensorsRoute
  '/service-items': typeof AuthGlobalServiceItemsRoute
  '/service-manager': typeof AuthGlobalServiceManagerRoute
  '/tos-agreements': typeof AuthGlobalTosAgreementsRoute
  '/webhook-events': typeof AuthGlobalWebhookEventsRoute
  '/cables/$id': typeof AuthCablesIdRoute
  '/challenges/new': typeof AuthChallengesNewRoute
  '/challenges/submit': typeof AuthChallengesSubmitRoute
  '/loggers/$id': typeof AuthLoggersIdRoute
  '/orgs/$id': typeof AuthOrgsIdRouteWithChildren
  '/projects/$id': typeof AuthProjectsIdRouteWithChildren
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/appearance': typeof AuthSettingsAppearanceRoute
  '/settings/beta': typeof AuthSettingsBetaRoute
  '/settings/thresholds': typeof AuthSettingsThresholdsRoute
  '/sites/$id': typeof AuthSitesIdRouteWithChildren
  '/users/$id': typeof AuthUsersIdRoute
  '/public/orgs/$id': typeof PublicOrgsIdRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/sites/$id': typeof PublicSitesIdRoute
  '/cables/': typeof AuthCablesIndexRoute
  '/challenges/': typeof AuthChallengesIndexRoute
  '/loggers/': typeof AuthLoggersIndexRoute
  '/orgs/': typeof AuthOrgsIndexRoute
  '/projects/': typeof AuthProjectsIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/sites/': typeof AuthSitesIndexRoute
  '/public/orgs/': typeof PublicOrgsIndexRoute
  '/public/projects/': typeof PublicProjectsIndexRoute
  '/public/sites/': typeof PublicSitesIndexRoute
  '/loggers/status': typeof AuthGlobalLoggersStatusRoute
  '/modems/$imei': typeof AuthGlobalModemsImeiRoute
  '/orders/$id': typeof AuthGlobalOrdersIdRoute
  '/page-admin/$pageType': typeof AuthGlobalPageAdminPageTypeRouteWithChildren
  '/report-templates/$id': typeof AuthGlobalReportTemplatesIdRoute
  '/orgs/$id/devices': typeof AuthOrgsIdDevicesRoute
  '/projects/$id/devices': typeof AuthProjectsIdDevicesRoute
  '/projects/$id/generate-report': typeof AuthProjectsIdGenerateReportRoute
  '/projects/$id/report': typeof AuthProjectsIdReportRoute
  '/projects/$id/wiv-report': typeof AuthProjectsIdWivReportRoute
  '/sites/$id/trumpet': typeof AuthSitesIdTrumpetRoute
  '/modems/': typeof AuthGlobalModemsIndexRoute
  '/orders/': typeof AuthGlobalOrdersIndexRoute
  '/page-admin/': typeof AuthGlobalPageAdminIndexRoute
  '/report-templates/': typeof AuthGlobalReportTemplatesIndexRoute
  '/users/': typeof AuthGlobalUsersIndexRoute
  '/orgs/$id/': typeof AuthOrgsIdIndexRoute
  '/projects/$id/': typeof AuthProjectsIdIndexRoute
  '/sites/$id/': typeof AuthSitesIdIndexRoute
  '/page-admin/$pageType/$idOrSlug': typeof AuthGlobalPageAdminPageTypeIdOrSlugRoute
  '/page-admin/$pageType/': typeof AuthGlobalPageAdminPageTypeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/access-denied': typeof AccessDeniedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mapping': typeof MappingRoute
  '/styles': typeof StylesRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/drafts': typeof AuthDraftsRoute
  '/landing': typeof AuthLandingRoute
  '/vcard': typeof AuthVcardRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/industries/$slug': typeof IndustriesSlugRoute
  '/magic/$id': typeof MagicIdRoute
  '/public/challenge': typeof PublicChallengeRoute
  '/reset/$id': typeof ResetIdRoute
  '/blog': typeof BlogIndexRoute
  '/public': typeof PublicIndexRoute
  '/bom-configuration': typeof AuthGlobalBomConfigurationRoute
  '/cable-pricing': typeof AuthGlobalCablePricingRoute
  '/commands': typeof AuthGlobalCommandsRoute
  '/contact-submissions': typeof AuthGlobalContactSubmissionsRoute
  '/data-usage-calculator': typeof AuthGlobalDataUsageCalculatorRoute
  '/devices': typeof AuthGlobalDevicesRoute
  '/forecast-requests': typeof AuthGlobalForecastRequestsRoute
  '/landing-content': typeof AuthGlobalLandingContentRoute
  '/logger-activations': typeof AuthGlobalLoggerActivationsRoute
  '/logger-firmware-management': typeof AuthGlobalLoggerFirmwareManagementRoute
  '/notifications': typeof AuthGlobalNotificationsRoute
  '/recent-users': typeof AuthGlobalRecentUsersRoute
  '/reconciliation': typeof AuthGlobalReconciliationRoute
  '/search': typeof AuthGlobalSearchRoute
  '/sensors': typeof AuthGlobalSensorsRoute
  '/service-items': typeof AuthGlobalServiceItemsRoute
  '/service-manager': typeof AuthGlobalServiceManagerRoute
  '/tos-agreements': typeof AuthGlobalTosAgreementsRoute
  '/webhook-events': typeof AuthGlobalWebhookEventsRoute
  '/cables/$id': typeof AuthCablesIdRoute
  '/challenges/new': typeof AuthChallengesNewRoute
  '/challenges/submit': typeof AuthChallengesSubmitRoute
  '/loggers/$id': typeof AuthLoggersIdRoute
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/appearance': typeof AuthSettingsAppearanceRoute
  '/settings/beta': typeof AuthSettingsBetaRoute
  '/settings/thresholds': typeof AuthSettingsThresholdsRoute
  '/users/$id': typeof AuthUsersIdRoute
  '/public/orgs/$id': typeof PublicOrgsIdRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/sites/$id': typeof PublicSitesIdRoute
  '/cables': typeof AuthCablesIndexRoute
  '/challenges': typeof AuthChallengesIndexRoute
  '/loggers': typeof AuthLoggersIndexRoute
  '/orgs': typeof AuthOrgsIndexRoute
  '/projects': typeof AuthProjectsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/sites': typeof AuthSitesIndexRoute
  '/public/orgs': typeof PublicOrgsIndexRoute
  '/public/projects': typeof PublicProjectsIndexRoute
  '/public/sites': typeof PublicSitesIndexRoute
  '/loggers/status': typeof AuthGlobalLoggersStatusRoute
  '/modems/$imei': typeof AuthGlobalModemsImeiRoute
  '/orders/$id': typeof AuthGlobalOrdersIdRoute
  '/report-templates/$id': typeof AuthGlobalReportTemplatesIdRoute
  '/orgs/$id/devices': typeof AuthOrgsIdDevicesRoute
  '/projects/$id/devices': typeof AuthProjectsIdDevicesRoute
  '/projects/$id/generate-report': typeof AuthProjectsIdGenerateReportRoute
  '/projects/$id/report': typeof AuthProjectsIdReportRoute
  '/projects/$id/wiv-report': typeof AuthProjectsIdWivReportRoute
  '/sites/$id/trumpet': typeof AuthSitesIdTrumpetRoute
  '/modems': typeof AuthGlobalModemsIndexRoute
  '/orders': typeof AuthGlobalOrdersIndexRoute
  '/page-admin': typeof AuthGlobalPageAdminIndexRoute
  '/report-templates': typeof AuthGlobalReportTemplatesIndexRoute
  '/users': typeof AuthGlobalUsersIndexRoute
  '/orgs/$id': typeof AuthOrgsIdIndexRoute
  '/projects/$id': typeof AuthProjectsIdIndexRoute
  '/sites/$id': typeof AuthSitesIdIndexRoute
  '/page-admin/$pageType/$idOrSlug': typeof AuthGlobalPageAdminPageTypeIdOrSlugRoute
  '/page-admin/$pageType': typeof AuthGlobalPageAdminPageTypeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/_auth': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mapping': typeof MappingRoute
  '/public': typeof PublicRouteWithChildren
  '/styles': typeof StylesRoute
  '/terms': typeof TermsRoute
  '/_auth/_global': typeof AuthGlobalRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/drafts': typeof AuthDraftsRoute
  '/_auth/landing': typeof AuthLandingRoute
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/_auth/vcard': typeof AuthVcardRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/industries/$slug': typeof IndustriesSlugRoute
  '/magic/$id': typeof MagicIdRoute
  '/public/challenge': typeof PublicChallengeRoute
  '/reset/$id': typeof ResetIdRoute
  '/blog/': typeof BlogIndexRoute
  '/public/': typeof PublicIndexRoute
  '/_auth/_global/bom-configuration': typeof AuthGlobalBomConfigurationRoute
  '/_auth/_global/cable-pricing': typeof AuthGlobalCablePricingRoute
  '/_auth/_global/commands': typeof AuthGlobalCommandsRoute
  '/_auth/_global/contact-submissions': typeof AuthGlobalContactSubmissionsRoute
  '/_auth/_global/data-usage-calculator': typeof AuthGlobalDataUsageCalculatorRoute
  '/_auth/_global/devices': typeof AuthGlobalDevicesRoute
  '/_auth/_global/forecast-requests': typeof AuthGlobalForecastRequestsRoute
  '/_auth/_global/landing-content': typeof AuthGlobalLandingContentRoute
  '/_auth/_global/logger-activations': typeof AuthGlobalLoggerActivationsRoute
  '/_auth/_global/logger-firmware-management': typeof AuthGlobalLoggerFirmwareManagementRoute
  '/_auth/_global/notifications': typeof AuthGlobalNotificationsRoute
  '/_auth/_global/recent-users': typeof AuthGlobalRecentUsersRoute
  '/_auth/_global/reconciliation': typeof AuthGlobalReconciliationRoute
  '/_auth/_global/search': typeof AuthGlobalSearchRoute
  '/_auth/_global/sensors': typeof AuthGlobalSensorsRoute
  '/_auth/_global/service-items': typeof AuthGlobalServiceItemsRoute
  '/_auth/_global/service-manager': typeof AuthGlobalServiceManagerRoute
  '/_auth/_global/tos-agreements': typeof AuthGlobalTosAgreementsRoute
  '/_auth/_global/webhook-events': typeof AuthGlobalWebhookEventsRoute
  '/_auth/cables/$id': typeof AuthCablesIdRoute
  '/_auth/challenges/new': typeof AuthChallengesNewRoute
  '/_auth/challenges/submit': typeof AuthChallengesSubmitRoute
  '/_auth/loggers/$id': typeof AuthLoggersIdRoute
  '/_auth/orgs/$id': typeof AuthOrgsIdRouteWithChildren
  '/_auth/projects/$id': typeof AuthProjectsIdRouteWithChildren
  '/_auth/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/_auth/settings/appearance': typeof AuthSettingsAppearanceRoute
  '/_auth/settings/beta': typeof AuthSettingsBetaRoute
  '/_auth/settings/thresholds': typeof AuthSettingsThresholdsRoute
  '/_auth/sites/$id': typeof AuthSitesIdRouteWithChildren
  '/_auth/users/$id': typeof AuthUsersIdRoute
  '/public/orgs/$id': typeof PublicOrgsIdRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/sites/$id': typeof PublicSitesIdRoute
  '/_auth/cables/': typeof AuthCablesIndexRoute
  '/_auth/challenges/': typeof AuthChallengesIndexRoute
  '/_auth/loggers/': typeof AuthLoggersIndexRoute
  '/_auth/orgs/': typeof AuthOrgsIndexRoute
  '/_auth/projects/': typeof AuthProjectsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/sites/': typeof AuthSitesIndexRoute
  '/public/orgs/': typeof PublicOrgsIndexRoute
  '/public/projects/': typeof PublicProjectsIndexRoute
  '/public/sites/': typeof PublicSitesIndexRoute
  '/_auth/_global/loggers/status': typeof AuthGlobalLoggersStatusRoute
  '/_auth/_global/modems/$imei': typeof AuthGlobalModemsImeiRoute
  '/_auth/_global/orders/$id': typeof AuthGlobalOrdersIdRoute
  '/_auth/_global/page-admin/$pageType': typeof AuthGlobalPageAdminPageTypeRouteWithChildren
  '/_auth/_global/report-templates/$id': typeof AuthGlobalReportTemplatesIdRoute
  '/_auth/orgs/$id/devices': typeof AuthOrgsIdDevicesRoute
  '/_auth/projects/$id/devices': typeof AuthProjectsIdDevicesRoute
  '/_auth/projects/$id/generate-report': typeof AuthProjectsIdGenerateReportRoute
  '/_auth/projects/$id/report': typeof AuthProjectsIdReportRoute
  '/_auth/projects/$id/wiv-report': typeof AuthProjectsIdWivReportRoute
  '/_auth/sites/$id/trumpet': typeof AuthSitesIdTrumpetRoute
  '/_auth/_global/modems/': typeof AuthGlobalModemsIndexRoute
  '/_auth/_global/orders/': typeof AuthGlobalOrdersIndexRoute
  '/_auth/_global/page-admin/': typeof AuthGlobalPageAdminIndexRoute
  '/_auth/_global/report-templates/': typeof AuthGlobalReportTemplatesIndexRoute
  '/_auth/_global/users/': typeof AuthGlobalUsersIndexRoute
  '/_auth/orgs/$id/': typeof AuthOrgsIdIndexRoute
  '/_auth/projects/$id/': typeof AuthProjectsIdIndexRoute
  '/_auth/sites/$id/': typeof AuthSitesIdIndexRoute
  '/_auth/_global/page-admin/$pageType/$idOrSlug': typeof AuthGlobalPageAdminPageTypeIdOrSlugRoute
  '/_auth/_global/page-admin/$pageType/': typeof AuthGlobalPageAdminPageTypeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/access-denied'
    | '/forgot-password'
    | '/login'
    | '/mapping'
    | '/public'
    | '/styles'
    | '/terms'
    | '/dashboard'
    | '/drafts'
    | '/landing'
    | '/settings'
    | '/vcard'
    | '/blog/$slug'
    | '/industries/$slug'
    | '/magic/$id'
    | '/public/challenge'
    | '/reset/$id'
    | '/blog/'
    | '/public/'
    | '/bom-configuration'
    | '/cable-pricing'
    | '/commands'
    | '/contact-submissions'
    | '/data-usage-calculator'
    | '/devices'
    | '/forecast-requests'
    | '/landing-content'
    | '/logger-activations'
    | '/logger-firmware-management'
    | '/notifications'
    | '/recent-users'
    | '/reconciliation'
    | '/search'
    | '/sensors'
    | '/service-items'
    | '/service-manager'
    | '/tos-agreements'
    | '/webhook-events'
    | '/cables/$id'
    | '/challenges/new'
    | '/challenges/submit'
    | '/loggers/$id'
    | '/orgs/$id'
    | '/projects/$id'
    | '/settings/api-keys'
    | '/settings/appearance'
    | '/settings/beta'
    | '/settings/thresholds'
    | '/sites/$id'
    | '/users/$id'
    | '/public/orgs/$id'
    | '/public/projects/$id'
    | '/public/sites/$id'
    | '/cables/'
    | '/challenges/'
    | '/loggers/'
    | '/orgs/'
    | '/projects/'
    | '/settings/'
    | '/sites/'
    | '/public/orgs/'
    | '/public/projects/'
    | '/public/sites/'
    | '/loggers/status'
    | '/modems/$imei'
    | '/orders/$id'
    | '/page-admin/$pageType'
    | '/report-templates/$id'
    | '/orgs/$id/devices'
    | '/projects/$id/devices'
    | '/projects/$id/generate-report'
    | '/projects/$id/report'
    | '/projects/$id/wiv-report'
    | '/sites/$id/trumpet'
    | '/modems/'
    | '/orders/'
    | '/page-admin/'
    | '/report-templates/'
    | '/users/'
    | '/orgs/$id/'
    | '/projects/$id/'
    | '/sites/$id/'
    | '/page-admin/$pageType/$idOrSlug'
    | '/page-admin/$pageType/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug'
    | '/access-denied'
    | '/forgot-password'
    | '/login'
    | '/mapping'
    | '/styles'
    | '/terms'
    | '/dashboard'
    | '/drafts'
    | '/landing'
    | '/vcard'
    | '/blog/$slug'
    | '/industries/$slug'
    | '/magic/$id'
    | '/public/challenge'
    | '/reset/$id'
    | '/blog'
    | '/public'
    | '/bom-configuration'
    | '/cable-pricing'
    | '/commands'
    | '/contact-submissions'
    | '/data-usage-calculator'
    | '/devices'
    | '/forecast-requests'
    | '/landing-content'
    | '/logger-activations'
    | '/logger-firmware-management'
    | '/notifications'
    | '/recent-users'
    | '/reconciliation'
    | '/search'
    | '/sensors'
    | '/service-items'
    | '/service-manager'
    | '/tos-agreements'
    | '/webhook-events'
    | '/cables/$id'
    | '/challenges/new'
    | '/challenges/submit'
    | '/loggers/$id'
    | '/settings/api-keys'
    | '/settings/appearance'
    | '/settings/beta'
    | '/settings/thresholds'
    | '/users/$id'
    | '/public/orgs/$id'
    | '/public/projects/$id'
    | '/public/sites/$id'
    | '/cables'
    | '/challenges'
    | '/loggers'
    | '/orgs'
    | '/projects'
    | '/settings'
    | '/sites'
    | '/public/orgs'
    | '/public/projects'
    | '/public/sites'
    | '/loggers/status'
    | '/modems/$imei'
    | '/orders/$id'
    | '/report-templates/$id'
    | '/orgs/$id/devices'
    | '/projects/$id/devices'
    | '/projects/$id/generate-report'
    | '/projects/$id/report'
    | '/projects/$id/wiv-report'
    | '/sites/$id/trumpet'
    | '/modems'
    | '/orders'
    | '/page-admin'
    | '/report-templates'
    | '/users'
    | '/orgs/$id'
    | '/projects/$id'
    | '/sites/$id'
    | '/page-admin/$pageType/$idOrSlug'
    | '/page-admin/$pageType'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/_auth'
    | '/access-denied'
    | '/forgot-password'
    | '/login'
    | '/mapping'
    | '/public'
    | '/styles'
    | '/terms'
    | '/_auth/_global'
    | '/_auth/dashboard'
    | '/_auth/drafts'
    | '/_auth/landing'
    | '/_auth/settings'
    | '/_auth/vcard'
    | '/blog/$slug'
    | '/industries/$slug'
    | '/magic/$id'
    | '/public/challenge'
    | '/reset/$id'
    | '/blog/'
    | '/public/'
    | '/_auth/_global/bom-configuration'
    | '/_auth/_global/cable-pricing'
    | '/_auth/_global/commands'
    | '/_auth/_global/contact-submissions'
    | '/_auth/_global/data-usage-calculator'
    | '/_auth/_global/devices'
    | '/_auth/_global/forecast-requests'
    | '/_auth/_global/landing-content'
    | '/_auth/_global/logger-activations'
    | '/_auth/_global/logger-firmware-management'
    | '/_auth/_global/notifications'
    | '/_auth/_global/recent-users'
    | '/_auth/_global/reconciliation'
    | '/_auth/_global/search'
    | '/_auth/_global/sensors'
    | '/_auth/_global/service-items'
    | '/_auth/_global/service-manager'
    | '/_auth/_global/tos-agreements'
    | '/_auth/_global/webhook-events'
    | '/_auth/cables/$id'
    | '/_auth/challenges/new'
    | '/_auth/challenges/submit'
    | '/_auth/loggers/$id'
    | '/_auth/orgs/$id'
    | '/_auth/projects/$id'
    | '/_auth/settings/api-keys'
    | '/_auth/settings/appearance'
    | '/_auth/settings/beta'
    | '/_auth/settings/thresholds'
    | '/_auth/sites/$id'
    | '/_auth/users/$id'
    | '/public/orgs/$id'
    | '/public/projects/$id'
    | '/public/sites/$id'
    | '/_auth/cables/'
    | '/_auth/challenges/'
    | '/_auth/loggers/'
    | '/_auth/orgs/'
    | '/_auth/projects/'
    | '/_auth/settings/'
    | '/_auth/sites/'
    | '/public/orgs/'
    | '/public/projects/'
    | '/public/sites/'
    | '/_auth/_global/loggers/status'
    | '/_auth/_global/modems/$imei'
    | '/_auth/_global/orders/$id'
    | '/_auth/_global/page-admin/$pageType'
    | '/_auth/_global/report-templates/$id'
    | '/_auth/orgs/$id/devices'
    | '/_auth/projects/$id/devices'
    | '/_auth/projects/$id/generate-report'
    | '/_auth/projects/$id/report'
    | '/_auth/projects/$id/wiv-report'
    | '/_auth/sites/$id/trumpet'
    | '/_auth/_global/modems/'
    | '/_auth/_global/orders/'
    | '/_auth/_global/page-admin/'
    | '/_auth/_global/report-templates/'
    | '/_auth/_global/users/'
    | '/_auth/orgs/$id/'
    | '/_auth/projects/$id/'
    | '/_auth/sites/$id/'
    | '/_auth/_global/page-admin/$pageType/$idOrSlug'
    | '/_auth/_global/page-admin/$pageType/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MappingRoute: typeof MappingRoute
  PublicRoute: typeof PublicRouteWithChildren
  StylesRoute: typeof StylesRoute
  TermsRoute: typeof TermsRoute
  BlogSlugRoute: typeof BlogSlugRoute
  IndustriesSlugRoute: typeof IndustriesSlugRoute
  MagicIdRoute: typeof MagicIdRoute
  ResetIdRoute: typeof ResetIdRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styles': {
      id: '/styles'
      path: '/styles'
      fullPath: '/styles'
      preLoaderRoute: typeof StylesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public': {
      id: '/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mapping': {
      id: '/mapping'
      path: '/mapping'
      fullPath: '/mapping'
      preLoaderRoute: typeof MappingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/': {
      id: '/public/'
      path: '/'
      fullPath: '/public/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset/$id': {
      id: '/reset/$id'
      path: '/reset/$id'
      fullPath: '/reset/$id'
      preLoaderRoute: typeof ResetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/challenge': {
      id: '/public/challenge'
      path: '/challenge'
      fullPath: '/public/challenge'
      preLoaderRoute: typeof PublicChallengeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/magic/$id': {
      id: '/magic/$id'
      path: '/magic/$id'
      fullPath: '/magic/$id'
      preLoaderRoute: typeof MagicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/$slug': {
      id: '/industries/$slug'
      path: '/industries/$slug'
      fullPath: '/industries/$slug'
      preLoaderRoute: typeof IndustriesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/vcard': {
      id: '/_auth/vcard'
      path: '/vcard'
      fullPath: '/vcard'
      preLoaderRoute: typeof AuthVcardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/landing': {
      id: '/_auth/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof AuthLandingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/drafts': {
      id: '/_auth/drafts'
      path: '/drafts'
      fullPath: '/drafts'
      preLoaderRoute: typeof AuthDraftsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_global': {
      id: '/_auth/_global'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthGlobalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/public/sites/': {
      id: '/public/sites/'
      path: '/sites'
      fullPath: '/public/sites/'
      preLoaderRoute: typeof PublicSitesIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/public/projects/': {
      id: '/public/projects/'
      path: '/projects'
      fullPath: '/public/projects/'
      preLoaderRoute: typeof PublicProjectsIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/public/orgs/': {
      id: '/public/orgs/'
      path: '/orgs'
      fullPath: '/public/orgs/'
      preLoaderRoute: typeof PublicOrgsIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/sites/': {
      id: '/_auth/sites/'
      path: '/sites'
      fullPath: '/sites/'
      preLoaderRoute: typeof AuthSitesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/projects/': {
      id: '/_auth/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthProjectsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orgs/': {
      id: '/_auth/orgs/'
      path: '/orgs'
      fullPath: '/orgs/'
      preLoaderRoute: typeof AuthOrgsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loggers/': {
      id: '/_auth/loggers/'
      path: '/loggers'
      fullPath: '/loggers/'
      preLoaderRoute: typeof AuthLoggersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/challenges/': {
      id: '/_auth/challenges/'
      path: '/challenges'
      fullPath: '/challenges/'
      preLoaderRoute: typeof AuthChallengesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cables/': {
      id: '/_auth/cables/'
      path: '/cables'
      fullPath: '/cables/'
      preLoaderRoute: typeof AuthCablesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/public/sites/$id': {
      id: '/public/sites/$id'
      path: '/sites/$id'
      fullPath: '/public/sites/$id'
      preLoaderRoute: typeof PublicSitesIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/public/projects/$id': {
      id: '/public/projects/$id'
      path: '/projects/$id'
      fullPath: '/public/projects/$id'
      preLoaderRoute: typeof PublicProjectsIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/public/orgs/$id': {
      id: '/public/orgs/$id'
      path: '/orgs/$id'
      fullPath: '/public/orgs/$id'
      preLoaderRoute: typeof PublicOrgsIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/users/$id': {
      id: '/_auth/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthUsersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sites/$id': {
      id: '/_auth/sites/$id'
      path: '/sites/$id'
      fullPath: '/sites/$id'
      preLoaderRoute: typeof AuthSitesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/thresholds': {
      id: '/_auth/settings/thresholds'
      path: '/thresholds'
      fullPath: '/settings/thresholds'
      preLoaderRoute: typeof AuthSettingsThresholdsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/beta': {
      id: '/_auth/settings/beta'
      path: '/beta'
      fullPath: '/settings/beta'
      preLoaderRoute: typeof AuthSettingsBetaRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/appearance': {
      id: '/_auth/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthSettingsAppearanceRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/api-keys': {
      id: '/_auth/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthSettingsApiKeysRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/projects/$id': {
      id: '/_auth/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AuthProjectsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orgs/$id': {
      id: '/_auth/orgs/$id'
      path: '/orgs/$id'
      fullPath: '/orgs/$id'
      preLoaderRoute: typeof AuthOrgsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loggers/$id': {
      id: '/_auth/loggers/$id'
      path: '/loggers/$id'
      fullPath: '/loggers/$id'
      preLoaderRoute: typeof AuthLoggersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/challenges/submit': {
      id: '/_auth/challenges/submit'
      path: '/challenges/submit'
      fullPath: '/challenges/submit'
      preLoaderRoute: typeof AuthChallengesSubmitRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/challenges/new': {
      id: '/_auth/challenges/new'
      path: '/challenges/new'
      fullPath: '/challenges/new'
      preLoaderRoute: typeof AuthChallengesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cables/$id': {
      id: '/_auth/cables/$id'
      path: '/cables/$id'
      fullPath: '/cables/$id'
      preLoaderRoute: typeof AuthCablesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_global/webhook-events': {
      id: '/_auth/_global/webhook-events'
      path: '/webhook-events'
      fullPath: '/webhook-events'
      preLoaderRoute: typeof AuthGlobalWebhookEventsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/tos-agreements': {
      id: '/_auth/_global/tos-agreements'
      path: '/tos-agreements'
      fullPath: '/tos-agreements'
      preLoaderRoute: typeof AuthGlobalTosAgreementsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/service-manager': {
      id: '/_auth/_global/service-manager'
      path: '/service-manager'
      fullPath: '/service-manager'
      preLoaderRoute: typeof AuthGlobalServiceManagerRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/service-items': {
      id: '/_auth/_global/service-items'
      path: '/service-items'
      fullPath: '/service-items'
      preLoaderRoute: typeof AuthGlobalServiceItemsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/sensors': {
      id: '/_auth/_global/sensors'
      path: '/sensors'
      fullPath: '/sensors'
      preLoaderRoute: typeof AuthGlobalSensorsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/search': {
      id: '/_auth/_global/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthGlobalSearchRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/reconciliation': {
      id: '/_auth/_global/reconciliation'
      path: '/reconciliation'
      fullPath: '/reconciliation'
      preLoaderRoute: typeof AuthGlobalReconciliationRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/recent-users': {
      id: '/_auth/_global/recent-users'
      path: '/recent-users'
      fullPath: '/recent-users'
      preLoaderRoute: typeof AuthGlobalRecentUsersRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/notifications': {
      id: '/_auth/_global/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthGlobalNotificationsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/logger-firmware-management': {
      id: '/_auth/_global/logger-firmware-management'
      path: '/logger-firmware-management'
      fullPath: '/logger-firmware-management'
      preLoaderRoute: typeof AuthGlobalLoggerFirmwareManagementRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/logger-activations': {
      id: '/_auth/_global/logger-activations'
      path: '/logger-activations'
      fullPath: '/logger-activations'
      preLoaderRoute: typeof AuthGlobalLoggerActivationsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/landing-content': {
      id: '/_auth/_global/landing-content'
      path: '/landing-content'
      fullPath: '/landing-content'
      preLoaderRoute: typeof AuthGlobalLandingContentRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/forecast-requests': {
      id: '/_auth/_global/forecast-requests'
      path: '/forecast-requests'
      fullPath: '/forecast-requests'
      preLoaderRoute: typeof AuthGlobalForecastRequestsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/devices': {
      id: '/_auth/_global/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthGlobalDevicesRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/data-usage-calculator': {
      id: '/_auth/_global/data-usage-calculator'
      path: '/data-usage-calculator'
      fullPath: '/data-usage-calculator'
      preLoaderRoute: typeof AuthGlobalDataUsageCalculatorRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/contact-submissions': {
      id: '/_auth/_global/contact-submissions'
      path: '/contact-submissions'
      fullPath: '/contact-submissions'
      preLoaderRoute: typeof AuthGlobalContactSubmissionsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/commands': {
      id: '/_auth/_global/commands'
      path: '/commands'
      fullPath: '/commands'
      preLoaderRoute: typeof AuthGlobalCommandsRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/cable-pricing': {
      id: '/_auth/_global/cable-pricing'
      path: '/cable-pricing'
      fullPath: '/cable-pricing'
      preLoaderRoute: typeof AuthGlobalCablePricingRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/bom-configuration': {
      id: '/_auth/_global/bom-configuration'
      path: '/bom-configuration'
      fullPath: '/bom-configuration'
      preLoaderRoute: typeof AuthGlobalBomConfigurationRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/sites/$id/': {
      id: '/_auth/sites/$id/'
      path: '/'
      fullPath: '/sites/$id/'
      preLoaderRoute: typeof AuthSitesIdIndexRouteImport
      parentRoute: typeof AuthSitesIdRoute
    }
    '/_auth/projects/$id/': {
      id: '/_auth/projects/$id/'
      path: '/'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof AuthProjectsIdIndexRouteImport
      parentRoute: typeof AuthProjectsIdRoute
    }
    '/_auth/orgs/$id/': {
      id: '/_auth/orgs/$id/'
      path: '/'
      fullPath: '/orgs/$id/'
      preLoaderRoute: typeof AuthOrgsIdIndexRouteImport
      parentRoute: typeof AuthOrgsIdRoute
    }
    '/_auth/_global/users/': {
      id: '/_auth/_global/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthGlobalUsersIndexRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/report-templates/': {
      id: '/_auth/_global/report-templates/'
      path: '/report-templates'
      fullPath: '/report-templates/'
      preLoaderRoute: typeof AuthGlobalReportTemplatesIndexRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/page-admin/': {
      id: '/_auth/_global/page-admin/'
      path: '/page-admin'
      fullPath: '/page-admin/'
      preLoaderRoute: typeof AuthGlobalPageAdminIndexRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/orders/': {
      id: '/_auth/_global/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthGlobalOrdersIndexRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/modems/': {
      id: '/_auth/_global/modems/'
      path: '/modems'
      fullPath: '/modems/'
      preLoaderRoute: typeof AuthGlobalModemsIndexRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/sites/$id/trumpet': {
      id: '/_auth/sites/$id/trumpet'
      path: '/trumpet'
      fullPath: '/sites/$id/trumpet'
      preLoaderRoute: typeof AuthSitesIdTrumpetRouteImport
      parentRoute: typeof AuthSitesIdRoute
    }
    '/_auth/projects/$id/wiv-report': {
      id: '/_auth/projects/$id/wiv-report'
      path: '/wiv-report'
      fullPath: '/projects/$id/wiv-report'
      preLoaderRoute: typeof AuthProjectsIdWivReportRouteImport
      parentRoute: typeof AuthProjectsIdRoute
    }
    '/_auth/projects/$id/report': {
      id: '/_auth/projects/$id/report'
      path: '/report'
      fullPath: '/projects/$id/report'
      preLoaderRoute: typeof AuthProjectsIdReportRouteImport
      parentRoute: typeof AuthProjectsIdRoute
    }
    '/_auth/projects/$id/generate-report': {
      id: '/_auth/projects/$id/generate-report'
      path: '/generate-report'
      fullPath: '/projects/$id/generate-report'
      preLoaderRoute: typeof AuthProjectsIdGenerateReportRouteImport
      parentRoute: typeof AuthProjectsIdRoute
    }
    '/_auth/projects/$id/devices': {
      id: '/_auth/projects/$id/devices'
      path: '/devices'
      fullPath: '/projects/$id/devices'
      preLoaderRoute: typeof AuthProjectsIdDevicesRouteImport
      parentRoute: typeof AuthProjectsIdRoute
    }
    '/_auth/orgs/$id/devices': {
      id: '/_auth/orgs/$id/devices'
      path: '/devices'
      fullPath: '/orgs/$id/devices'
      preLoaderRoute: typeof AuthOrgsIdDevicesRouteImport
      parentRoute: typeof AuthOrgsIdRoute
    }
    '/_auth/_global/report-templates/$id': {
      id: '/_auth/_global/report-templates/$id'
      path: '/report-templates/$id'
      fullPath: '/report-templates/$id'
      preLoaderRoute: typeof AuthGlobalReportTemplatesIdRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/page-admin/$pageType': {
      id: '/_auth/_global/page-admin/$pageType'
      path: '/page-admin/$pageType'
      fullPath: '/page-admin/$pageType'
      preLoaderRoute: typeof AuthGlobalPageAdminPageTypeRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/orders/$id': {
      id: '/_auth/_global/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AuthGlobalOrdersIdRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/modems/$imei': {
      id: '/_auth/_global/modems/$imei'
      path: '/modems/$imei'
      fullPath: '/modems/$imei'
      preLoaderRoute: typeof AuthGlobalModemsImeiRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/loggers/status': {
      id: '/_auth/_global/loggers/status'
      path: '/loggers/status'
      fullPath: '/loggers/status'
      preLoaderRoute: typeof AuthGlobalLoggersStatusRouteImport
      parentRoute: typeof AuthGlobalRoute
    }
    '/_auth/_global/page-admin/$pageType/': {
      id: '/_auth/_global/page-admin/$pageType/'
      path: '/'
      fullPath: '/page-admin/$pageType/'
      preLoaderRoute: typeof AuthGlobalPageAdminPageTypeIndexRouteImport
      parentRoute: typeof AuthGlobalPageAdminPageTypeRoute
    }
    '/_auth/_global/page-admin/$pageType/$idOrSlug': {
      id: '/_auth/_global/page-admin/$pageType/$idOrSlug'
      path: '/$idOrSlug'
      fullPath: '/page-admin/$pageType/$idOrSlug'
      preLoaderRoute: typeof AuthGlobalPageAdminPageTypeIdOrSlugRouteImport
      parentRoute: typeof AuthGlobalPageAdminPageTypeRoute
    }
  }
}

interface AuthGlobalPageAdminPageTypeRouteChildren {
  AuthGlobalPageAdminPageTypeIdOrSlugRoute: typeof AuthGlobalPageAdminPageTypeIdOrSlugRoute
  AuthGlobalPageAdminPageTypeIndexRoute: typeof AuthGlobalPageAdminPageTypeIndexRoute
}

const AuthGlobalPageAdminPageTypeRouteChildren: AuthGlobalPageAdminPageTypeRouteChildren =
  {
    AuthGlobalPageAdminPageTypeIdOrSlugRoute:
      AuthGlobalPageAdminPageTypeIdOrSlugRoute,
    AuthGlobalPageAdminPageTypeIndexRoute:
      AuthGlobalPageAdminPageTypeIndexRoute,
  }

const AuthGlobalPageAdminPageTypeRouteWithChildren =
  AuthGlobalPageAdminPageTypeRoute._addFileChildren(
    AuthGlobalPageAdminPageTypeRouteChildren,
  )

interface AuthGlobalRouteChildren {
  AuthGlobalBomConfigurationRoute: typeof AuthGlobalBomConfigurationRoute
  AuthGlobalCablePricingRoute: typeof AuthGlobalCablePricingRoute
  AuthGlobalCommandsRoute: typeof AuthGlobalCommandsRoute
  AuthGlobalContactSubmissionsRoute: typeof AuthGlobalContactSubmissionsRoute
  AuthGlobalDataUsageCalculatorRoute: typeof AuthGlobalDataUsageCalculatorRoute
  AuthGlobalDevicesRoute: typeof AuthGlobalDevicesRoute
  AuthGlobalForecastRequestsRoute: typeof AuthGlobalForecastRequestsRoute
  AuthGlobalLandingContentRoute: typeof AuthGlobalLandingContentRoute
  AuthGlobalLoggerActivationsRoute: typeof AuthGlobalLoggerActivationsRoute
  AuthGlobalLoggerFirmwareManagementRoute: typeof AuthGlobalLoggerFirmwareManagementRoute
  AuthGlobalNotificationsRoute: typeof AuthGlobalNotificationsRoute
  AuthGlobalRecentUsersRoute: typeof AuthGlobalRecentUsersRoute
  AuthGlobalReconciliationRoute: typeof AuthGlobalReconciliationRoute
  AuthGlobalSearchRoute: typeof AuthGlobalSearchRoute
  AuthGlobalSensorsRoute: typeof AuthGlobalSensorsRoute
  AuthGlobalServiceItemsRoute: typeof AuthGlobalServiceItemsRoute
  AuthGlobalServiceManagerRoute: typeof AuthGlobalServiceManagerRoute
  AuthGlobalTosAgreementsRoute: typeof AuthGlobalTosAgreementsRoute
  AuthGlobalWebhookEventsRoute: typeof AuthGlobalWebhookEventsRoute
  AuthGlobalLoggersStatusRoute: typeof AuthGlobalLoggersStatusRoute
  AuthGlobalModemsImeiRoute: typeof AuthGlobalModemsImeiRoute
  AuthGlobalOrdersIdRoute: typeof AuthGlobalOrdersIdRoute
  AuthGlobalPageAdminPageTypeRoute: typeof AuthGlobalPageAdminPageTypeRouteWithChildren
  AuthGlobalReportTemplatesIdRoute: typeof AuthGlobalReportTemplatesIdRoute
  AuthGlobalModemsIndexRoute: typeof AuthGlobalModemsIndexRoute
  AuthGlobalOrdersIndexRoute: typeof AuthGlobalOrdersIndexRoute
  AuthGlobalPageAdminIndexRoute: typeof AuthGlobalPageAdminIndexRoute
  AuthGlobalReportTemplatesIndexRoute: typeof AuthGlobalReportTemplatesIndexRoute
  AuthGlobalUsersIndexRoute: typeof AuthGlobalUsersIndexRoute
}

const AuthGlobalRouteChildren: AuthGlobalRouteChildren = {
  AuthGlobalBomConfigurationRoute: AuthGlobalBomConfigurationRoute,
  AuthGlobalCablePricingRoute: AuthGlobalCablePricingRoute,
  AuthGlobalCommandsRoute: AuthGlobalCommandsRoute,
  AuthGlobalContactSubmissionsRoute: AuthGlobalContactSubmissionsRoute,
  AuthGlobalDataUsageCalculatorRoute: AuthGlobalDataUsageCalculatorRoute,
  AuthGlobalDevicesRoute: AuthGlobalDevicesRoute,
  AuthGlobalForecastRequestsRoute: AuthGlobalForecastRequestsRoute,
  AuthGlobalLandingContentRoute: AuthGlobalLandingContentRoute,
  AuthGlobalLoggerActivationsRoute: AuthGlobalLoggerActivationsRoute,
  AuthGlobalLoggerFirmwareManagementRoute:
    AuthGlobalLoggerFirmwareManagementRoute,
  AuthGlobalNotificationsRoute: AuthGlobalNotificationsRoute,
  AuthGlobalRecentUsersRoute: AuthGlobalRecentUsersRoute,
  AuthGlobalReconciliationRoute: AuthGlobalReconciliationRoute,
  AuthGlobalSearchRoute: AuthGlobalSearchRoute,
  AuthGlobalSensorsRoute: AuthGlobalSensorsRoute,
  AuthGlobalServiceItemsRoute: AuthGlobalServiceItemsRoute,
  AuthGlobalServiceManagerRoute: AuthGlobalServiceManagerRoute,
  AuthGlobalTosAgreementsRoute: AuthGlobalTosAgreementsRoute,
  AuthGlobalWebhookEventsRoute: AuthGlobalWebhookEventsRoute,
  AuthGlobalLoggersStatusRoute: AuthGlobalLoggersStatusRoute,
  AuthGlobalModemsImeiRoute: AuthGlobalModemsImeiRoute,
  AuthGlobalOrdersIdRoute: AuthGlobalOrdersIdRoute,
  AuthGlobalPageAdminPageTypeRoute:
    AuthGlobalPageAdminPageTypeRouteWithChildren,
  AuthGlobalReportTemplatesIdRoute: AuthGlobalReportTemplatesIdRoute,
  AuthGlobalModemsIndexRoute: AuthGlobalModemsIndexRoute,
  AuthGlobalOrdersIndexRoute: AuthGlobalOrdersIndexRoute,
  AuthGlobalPageAdminIndexRoute: AuthGlobalPageAdminIndexRoute,
  AuthGlobalReportTemplatesIndexRoute: AuthGlobalReportTemplatesIndexRoute,
  AuthGlobalUsersIndexRoute: AuthGlobalUsersIndexRoute,
}

const AuthGlobalRouteWithChildren = AuthGlobalRoute._addFileChildren(
  AuthGlobalRouteChildren,
)

interface AuthSettingsRouteChildren {
  AuthSettingsApiKeysRoute: typeof AuthSettingsApiKeysRoute
  AuthSettingsAppearanceRoute: typeof AuthSettingsAppearanceRoute
  AuthSettingsBetaRoute: typeof AuthSettingsBetaRoute
  AuthSettingsThresholdsRoute: typeof AuthSettingsThresholdsRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsApiKeysRoute: AuthSettingsApiKeysRoute,
  AuthSettingsAppearanceRoute: AuthSettingsAppearanceRoute,
  AuthSettingsBetaRoute: AuthSettingsBetaRoute,
  AuthSettingsThresholdsRoute: AuthSettingsThresholdsRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthOrgsIdRouteChildren {
  AuthOrgsIdDevicesRoute: typeof AuthOrgsIdDevicesRoute
  AuthOrgsIdIndexRoute: typeof AuthOrgsIdIndexRoute
}

const AuthOrgsIdRouteChildren: AuthOrgsIdRouteChildren = {
  AuthOrgsIdDevicesRoute: AuthOrgsIdDevicesRoute,
  AuthOrgsIdIndexRoute: AuthOrgsIdIndexRoute,
}

const AuthOrgsIdRouteWithChildren = AuthOrgsIdRoute._addFileChildren(
  AuthOrgsIdRouteChildren,
)

interface AuthProjectsIdRouteChildren {
  AuthProjectsIdDevicesRoute: typeof AuthProjectsIdDevicesRoute
  AuthProjectsIdGenerateReportRoute: typeof AuthProjectsIdGenerateReportRoute
  AuthProjectsIdReportRoute: typeof AuthProjectsIdReportRoute
  AuthProjectsIdWivReportRoute: typeof AuthProjectsIdWivReportRoute
  AuthProjectsIdIndexRoute: typeof AuthProjectsIdIndexRoute
}

const AuthProjectsIdRouteChildren: AuthProjectsIdRouteChildren = {
  AuthProjectsIdDevicesRoute: AuthProjectsIdDevicesRoute,
  AuthProjectsIdGenerateReportRoute: AuthProjectsIdGenerateReportRoute,
  AuthProjectsIdReportRoute: AuthProjectsIdReportRoute,
  AuthProjectsIdWivReportRoute: AuthProjectsIdWivReportRoute,
  AuthProjectsIdIndexRoute: AuthProjectsIdIndexRoute,
}

const AuthProjectsIdRouteWithChildren = AuthProjectsIdRoute._addFileChildren(
  AuthProjectsIdRouteChildren,
)

interface AuthSitesIdRouteChildren {
  AuthSitesIdTrumpetRoute: typeof AuthSitesIdTrumpetRoute
  AuthSitesIdIndexRoute: typeof AuthSitesIdIndexRoute
}

const AuthSitesIdRouteChildren: AuthSitesIdRouteChildren = {
  AuthSitesIdTrumpetRoute: AuthSitesIdTrumpetRoute,
  AuthSitesIdIndexRoute: AuthSitesIdIndexRoute,
}

const AuthSitesIdRouteWithChildren = AuthSitesIdRoute._addFileChildren(
  AuthSitesIdRouteChildren,
)

interface AuthRouteChildren {
  AuthGlobalRoute: typeof AuthGlobalRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthDraftsRoute: typeof AuthDraftsRoute
  AuthLandingRoute: typeof AuthLandingRoute
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthVcardRoute: typeof AuthVcardRoute
  AuthCablesIdRoute: typeof AuthCablesIdRoute
  AuthChallengesNewRoute: typeof AuthChallengesNewRoute
  AuthChallengesSubmitRoute: typeof AuthChallengesSubmitRoute
  AuthLoggersIdRoute: typeof AuthLoggersIdRoute
  AuthOrgsIdRoute: typeof AuthOrgsIdRouteWithChildren
  AuthProjectsIdRoute: typeof AuthProjectsIdRouteWithChildren
  AuthSitesIdRoute: typeof AuthSitesIdRouteWithChildren
  AuthUsersIdRoute: typeof AuthUsersIdRoute
  AuthCablesIndexRoute: typeof AuthCablesIndexRoute
  AuthChallengesIndexRoute: typeof AuthChallengesIndexRoute
  AuthLoggersIndexRoute: typeof AuthLoggersIndexRoute
  AuthOrgsIndexRoute: typeof AuthOrgsIndexRoute
  AuthProjectsIndexRoute: typeof AuthProjectsIndexRoute
  AuthSitesIndexRoute: typeof AuthSitesIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthGlobalRoute: AuthGlobalRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthDraftsRoute: AuthDraftsRoute,
  AuthLandingRoute: AuthLandingRoute,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthVcardRoute: AuthVcardRoute,
  AuthCablesIdRoute: AuthCablesIdRoute,
  AuthChallengesNewRoute: AuthChallengesNewRoute,
  AuthChallengesSubmitRoute: AuthChallengesSubmitRoute,
  AuthLoggersIdRoute: AuthLoggersIdRoute,
  AuthOrgsIdRoute: AuthOrgsIdRouteWithChildren,
  AuthProjectsIdRoute: AuthProjectsIdRouteWithChildren,
  AuthSitesIdRoute: AuthSitesIdRouteWithChildren,
  AuthUsersIdRoute: AuthUsersIdRoute,
  AuthCablesIndexRoute: AuthCablesIndexRoute,
  AuthChallengesIndexRoute: AuthChallengesIndexRoute,
  AuthLoggersIndexRoute: AuthLoggersIndexRoute,
  AuthOrgsIndexRoute: AuthOrgsIndexRoute,
  AuthProjectsIndexRoute: AuthProjectsIndexRoute,
  AuthSitesIndexRoute: AuthSitesIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicChallengeRoute: typeof PublicChallengeRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicOrgsIdRoute: typeof PublicOrgsIdRoute
  PublicProjectsIdRoute: typeof PublicProjectsIdRoute
  PublicSitesIdRoute: typeof PublicSitesIdRoute
  PublicOrgsIndexRoute: typeof PublicOrgsIndexRoute
  PublicProjectsIndexRoute: typeof PublicProjectsIndexRoute
  PublicSitesIndexRoute: typeof PublicSitesIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicChallengeRoute: PublicChallengeRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicOrgsIdRoute: PublicOrgsIdRoute,
  PublicProjectsIdRoute: PublicProjectsIdRoute,
  PublicSitesIdRoute: PublicSitesIdRoute,
  PublicOrgsIndexRoute: PublicOrgsIndexRoute,
  PublicProjectsIndexRoute: PublicProjectsIndexRoute,
  PublicSitesIndexRoute: PublicSitesIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRoute,
  AuthRoute: AuthRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MappingRoute: MappingRoute,
  PublicRoute: PublicRouteWithChildren,
  StylesRoute: StylesRoute,
  TermsRoute: TermsRoute,
  BlogSlugRoute: BlogSlugRoute,
  IndustriesSlugRoute: IndustriesSlugRoute,
  MagicIdRoute: MagicIdRoute,
  ResetIdRoute: ResetIdRoute,
  BlogIndexRoute: BlogIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
